import { defineMessages } from 'react-intl';

export default defineMessages({
  moreButtonLabel: {
    id: 'frontbucket.horizontalNav.moreButtonLabel',
    description:
      'Label for the button which when clicked reveals the More menu.',
    defaultMessage: 'More',
  },
  moreButtonAriaLabel: {
    id: 'frontbucket.horizontalNav.moreButtonAriaLabel',
    description:
      'Aria label for the button which when clicked reveals the More menu.',
    defaultMessage: 'Toggle additional navigation links menu',
  },
});
